import { allMovies, latestIds } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function LatestSection() {
  const latest = latestIds
    .map((id) => allMovies.find((movie) => movie.id === id))
    .filter((movie): movie is (typeof allMovies)[number] => Boolean(movie));

  return (
    <section id="latest" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-8">
        <SectionHeading
          eyebrow="最新大片"
          title="近期上新的热门影片合集"
          subtitle="紧贴档期与话题热度的新片速览，标注上映年份与类型标签，方便你快速判断是否合胃口。"
        />

        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {latest.map((movie, index) => (
            <div key={movie.id} className="relative">
              <MovieCard movie={movie} />
              {index < 3 ? (
                <span className="absolute -top-2 left-3 rounded-md bg-primary-600 px-2 py-0.5 font-label text-[11px] font-bold text-background-50">
                  新片
                </span>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}